module.exports = __webpack_public_path__ + "img/icon.d9d4bc95.png";